const _ = require("lodash");
function canNavEvent(eventNode) {
  return !!_.get(eventNode, "frontmatter.description");
}

module.exports = { canNavEvent };
